import { ApolloProvider } from "@apollo/client";
import "@fontsource/inter/variable-full.css";
import { StyledEngineProvider } from "@mui/material";
import { initDatadogRum } from "@notemeal/reporting/datadog-rum";
import { ClientTimezoneContextProvider } from "@notemeal/shared/ui/contexts/ClientTimezone";
import "@teamworksdev/react/dist/index.css";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { CompatRouter } from "react-router-dom-v5-compat";
import App from "./App";
import client from "./client";
import { SnackbarContextProvider } from "./components/Snackbar/SnackbarContext";
import { CookieContextProvider } from "./contexts/Cookie";
import { ThemeModeContextProvider } from "./pages/Theme/ThemeModeContextProvider";

initDatadogRum({
  applicationId: "44bdbca4-8dcf-42b7-b844-102aa58eefbe",
  clientToken: "pub88d883e6b6b4db3d43e5bc9202ef7c52",
  service: "notemeal-web",
  version: process.env.REACT_APP_COMMIT_HASH,
  env: process.env.NODE_ENV,
  sessionReplaySampleRate: 100,
});

ReactDOM.render(
  <CookieContextProvider>
    <StyledEngineProvider injectFirst>
      <ThemeModeContextProvider>
        <ApolloProvider client={client}>
          <ClientTimezoneContextProvider>
            <SnackbarContextProvider>
              <BrowserRouter>
                <CompatRouter>
                  <App />
                </CompatRouter>
              </BrowserRouter>
            </SnackbarContextProvider>
          </ClientTimezoneContextProvider>
        </ApolloProvider>
      </ThemeModeContextProvider>
    </StyledEngineProvider>
  </CookieContextProvider>,
  document.getElementById("root")
);
